export const useRequest: typeof useFetch = (request, opts) => {
  const { $request } = useNuxtApp()
  return useFetch(request, {
    $fetch: $request,
    ...opts,
  })
}
